import { Spacing } from '@vkontakte/vkui';
import promoImg from 'img/baz/modal-image.png';
import React from 'react';
import { helpLink, productId } from 'reactApp/appHelpers/featuresHelpers/features/bazModalAfterCloseOverquota';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { loadProductsAndOpenFastCheckout } from 'reactApp/modules/payment/payment.module';
import { store } from 'reactApp/store';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

import styles from './AfterCloseOverquotaModal.css';

const sendRadar = (action: 'show' | 'click' | 'close' | 'buy' | 'close_buy') => {
    sendXray(['overq-baz-modal', action]);
    sendDwh({
        eventCategory: 'modal',
        action,
        dwhData: { name: 'mnz_overquota_promo_unlimited_autoload' },
    });
};

export const renderBazModalAfterCloseOverquotaModal = () => {
    const getTitle = () => {
        return <p>Избежать удаления файлов помогут 256&nbsp;ГБ&nbsp;с&nbsp;безлимитом</p>;
    };

    const getPrimaryButton = () => {
        return <span>Забрать 256&nbsp;ГБ</span>;
    };

    const getImage = () => {
        return promoImg;
    };

    const primaryClickHandler = () => {
        sendRadar('click');

        store.dispatch(
            loadProductsAndOpenFastCheckout({
                productId,
                title: 'Подписка Mail Space: 256 ГБ, безлимит',
                paySource: getPaySource('modal_web_overquota_promo_unlimited_autoload'),
                onSuccess: () => {
                    sendRadar('buy');
                },
                onClose: () => {
                    sendRadar('close_buy');
                },
            })
        );
    };

    return renderCommonWhatsNewDialog({
        title: getTitle(),
        content: (
            <>
                <Spacing size={12} />
                <span>
                    Файлам хватит места. А&nbsp;
                    <a target="_blank" href={helpLink} rel="noreferrer">
                        безлимит
                    </a>{' '}
                    это&nbsp;страховка на&nbsp;будущее&nbsp;— с&nbsp;ним&nbsp;новые фото с&nbsp;телефона не&nbsp;тратят память Облака
                </span>
                <Spacing size={24} />
            </>
        ),
        primaryButtonText: getPrimaryButton(),
        imageUrl: getImage(),
        onClick: primaryClickHandler,
        onDismiss: () => {
            sendRadar('close');
        },
        onShow: () => {
            sendRadar('show');
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        className: styles.root,
        contentClassName: styles.content,
        imageClassName: styles.image,
        closeAfterClick: true,
        closeIconClassName: styles.closeIcon,
    });
};
